export const SUPPORT_NUMBER = '8334846359'
